/**
 * The web app's logger. The browser console is the only sink for now; every log in the web
 * app goes through here so a remote sink can be added in one place.
 */
export const logger = {
  warn(message: string, detail?: Record<string, unknown>): void {
    console.warn(`[web] ${message}`, detail ?? {});
  },
};
